import { render, staticRenderFns } from "./relationalCalculator.vue?vue&type=template&id=a664cf3a&"
import script from "./relationalCalculator.vue?vue&type=script&lang=js&"
export * from "./relationalCalculator.vue?vue&type=script&lang=js&"
import style0 from "./relationalCalculator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports